import { createToast } from '@maui/elements'
import { useCreateThreatProfileNotification, useUpdateThreatProfileNotification } from '@nautilusjs/mati-apis'

const normalizePayload = (data, dirtyFields) => {
  const displayName = {}
  if (!dirtyFields || (dirtyFields && dirtyFields.name)) {
    displayName.display_name = data.name
  }
  const days = []
  if (data.deliveryFreq === 'WEEKLY') {
    if (typeof data.deliveryDays === 'string') {
      days.push(data.deliveryDays)
    } else {
      days.push(...data.deliveryDays[0])
    }
  } else {
    days.push(...data.deliveryDays)
  }
  const payload = {
    config: {
      profile_id: data.tpName.replace('profiles/', ''),
    },
    schedule: {
      type: 'WEEKLY',
      days,
      day_schedule: {
        type: 'DAILY',
        hour: parseInt(data.deliveryTime),
        time_zone: data.timeZone,
        ignore_dst: !!data.enableDayLightSavings.length
      }
    },
    enabled: true,
    type: 'threat_profile_digest',
    ...displayName
  }
  return payload
}

export const useThreatProfilesNotifications = ({ onClose, editData }) => {
  const { mutate: createNew, isLoading: isCreating, error: createError } = useCreateThreatProfileNotification({
    onSuccess: ({ display_name: displayName }) => {
      createToast({
        variant: 'success',
        title: 'Success',
        message: `Profile ${displayName} created successfully`,
        duration: 5000
      })
      onClose()
    },
    onError: () => {
      createToast({
        variant: 'error',
        title: 'Error',
        message: 'There was an error creating your profile; please try again',
        duration: 15000
      })
    }
  })

  const { mutate: updateExisting, isLoading: isUpdating, error: updateError } = useUpdateThreatProfileNotification({
    onSuccess: ({ display_name: displayName }) => {
      createToast({
        variant: 'success',
        title: 'Success',
        message: `Profile ${displayName} updated successfully`,
        duration: 5000
      })
      onClose()
    },
    onError: () => {
      createToast({
        variant: 'error',
        title: 'Error',
        message: 'There was an error updating your profile; please try again',
        duration: 15000
      })
    }
  })

  const onSubmit = (dirtyFields) => (data) => {
    if (editData?.name) {
      const payload = normalizePayload(data, dirtyFields)
      updateExisting({ id: encodeURIComponent(editData.name), payload })
    } else {
      const payload = normalizePayload(data)
      createNew(payload)
    }
  }
  const isSubmitting = isCreating || isUpdating
  const error = createError || updateError

  return {
    onSubmit,
    isSubmitting,
    error,
  }
}
